import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Box from '@mui/material/Box'
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo'
import { CONTENT_COLUMN_MAX_WIDTH } from './contentColumn'
import 'react-html5-camera-photo/build/css/index.css';

const CameraSettings = {
  idealFacingMode: FACING_MODES.USER,
  sizeFactor: 1,
  imageType: IMAGE_TYPES.JPG,
  imageCompression: 0.97,
}

const CameraDrawer = ({ onPhotoComplete, showCamera }) => {

  const onTakePhoto = (dataURI) => {
    onPhotoComplete(dataURI)
  }

  // Only mount the Camera component when the drawer is open so that
  // the browser does not prompt for camera access until the user has
  // explicitly chosen to take a photo.
  return showCamera ? (
    <SwipeableDrawer
      anchor="top"
      open={showCamera}
      onClose={()=>{}}
      onOpen={()=>{}}
      ModalProps={{
        sx: {
          zIndex: 1000 // Lower than default drawer/appbar zIndex
        }
      }}
      PaperProps={{
        sx: {
          width: '100%',
          margin: '0 auto',
          left: 0,
          right: 0,
          top: '76px', // Adjust for header height + padding
          height: 'auto',
          maxHeight: 'calc(100vh - 76px)',
          background: 'transparent',
          boxShadow: 'none',
          maxWidth: CONTENT_COLUMN_MAX_WIDTH
        }
      }}
    >
      <Box sx={{
          height: '65vh', // Slightly reduced height to fit nicely below header
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
          bgcolor: '#000',
          borderRadius: '0 0 16px 16px', // Rounded bottom corners
          '& .react-html5-camera-photo': { height: '100%', width: '100%' },
          '& video': { height: '100%', width: '100%', objectFit: 'cover' }
        }}
      >
        <Camera
          onTakePhoto={(dataURI) => onTakePhoto(dataURI)}
          idealFacingMode={CameraSettings.idealFacingMode}
          sizeFactor={CameraSettings.sizeFactor}
          imageType={CameraSettings.imageType}
          imageCompression={CameraSettings.imageCompression}
          isImageMirror={true}
        />

        {/* Circular mask overlay. Use CSS mask-image to avoid visible "ring" artifacts. */}
        <Box
          data-anear="camera-mask-overlay"
          aria-hidden="true"
          sx={{
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            backgroundColor: 'rgba(0,0,0,0.65)',
            //
            // Punch a circular hole using a mask. This avoids the double-edge /
            // faint border that can appear with visible gradients.
            //
            WebkitMaskImage:
              'radial-gradient(circle at 54% 50%, transparent 0 38%, rgba(0,0,0,1) 39% 100%)',
            maskImage:
              'radial-gradient(circle at 54% 50%, transparent 0 38%, rgba(0,0,0,1) 39% 100%)',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskSize: 'cover',
            maskSize: 'cover',
          }}
        />
      </Box>
    </SwipeableDrawer>
  ) : null
}

export default CameraDrawer
